module.exports = __webpack_public_path__ + "static/media/image_blue.ebb89bca.png";